<template> 
  <main>
    <Banner :animate="true" class="nobgcolor"/>  
    <Artconfig/>
  </main>
</template>

<script>
// @ is an alias to /src
import Banner from '@/components/Banner.vue';
import Artconfig from '@/components/Artconfig.vue';

export default {
  name: 'Home',
  components: {
    Banner,
    Artconfig
  },
  metaInfo: {
      title: "Typography Infused Street Photography With Love",
      meta: [        
        { vmid: "og:title", property: "og:title", content: "Typography Infused Street Photography With Love" },
        { vmid: "description", name: "description", content: "Explore the map, create yours &amp; share! Get it framed and spark up your living space with it!" },
        { vmid: "og:description", property: "og:description", content: "Explore the map, create yours &amp; share! Get it framed and spark up your living space with it!" }                                
      ],    
  },
}
</script>
